import React, { Component } from 'react';
import { connect } from 'react-redux';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { UnauthenticatedRoute, AuthenticatedRoute } from './AuthRoute';
import { getCookie } from './utils/Common';
import { getCurrentUserDetail } from './stores/auth';

import './scss/style.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

class App extends Component {
  constructor() {
    super();
    this.state = { data: [] };
  }

  // async componentDidMount() {
  //   console.log('asd');
  // }

  render() {
    // Check store if access_token not available
    if (!this.props.auth.access_token) {
      // if there's no access_token in store, check to browser cookie
      const access_token = getCookie('access_token');
      if (access_token) {
        // if access_token exist in cookie automatically get user detail
        this.props.getCurrentUser(access_token);
      } else {
        // TODO setup auto logout
      }
    }
    // getCookie() ? Auth.login() : Auth.logout();
    // getToken() ? Auth.login() : Auth.logout();

    return (
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <UnauthenticatedRoute
              exact
              path="/login"
              name="Login Page"
              component={Login}
            />
            <Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={(props) => <Page500 {...props} />}
            />
            <AuthenticatedRoute path="/" name="Home" component={TheLayout} />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCurrentUser: (access_token) =>
      dispatch(getCurrentUserDetail(access_token)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
